import React from "react";
import Cards from "./Cards";
import "./MostPopular.css";
import { useTranslation } from "react-i18next";
const MostPopular = () => {
  const { t } = useTranslation();
  return (
    <>
      <section className="popular top">
        <div className="full_container">
          <div className="heading">
            <h1>{t("shara")}</h1>
          </div>
          <div className="content">
            <Cards />
          </div>
        </div>
      </section>
    </>
  );
};

export default MostPopular;
